import React, { useEffect } from "react";
import "./PathAhead.scss";
import AOS from 'aos';
import 'aos/dist/aos.css';
const roadmapData = [
	{
		quarter: "Q1",
		phase: "Phase 1",
		title: "Foundation & Development",
		points: [
			"Finalization of Whitepaper & Tokenomics",
			"Smart Contract Development & Security Audit",
			"Legal Registration & Compliance Framework Setup",
			"UI/UX Design & UniWallet Pay Prototype Development",
		],
	},
	{
		quarter: "Q2",
		phase: "Phase 2",
		title: "Private & Public Fundraising",
		points: [
			"Private Token Sale (Strategic & Accredited Investors)",
			"Public Sale (ICO) & Community Airdrops",
			"Partnership Announcements & Exchange Pre-Listing Agreements",
			"Beta Release of UniWallet Pay (Web & Mobile App)",
		],
	},
	{
		quarter: "Q3",
		phase: "Phase 3",
		title: "Product Launch & Exchange Listings",
		points: [
			"Token Generation Event (TGE) & Smart Contract Deployment",
			"Listing on Major DEXs (Uniswap, PancakeSwap) & CEXs (KuCoin, Gate.io, OKX)",
			"Launch of Staking & Rewards System",
			"Merchant API Integration & Cross-Border Payment Activation",
		],
	},
	{
		quarter: "Q4",
		phase: "Phase 4",
		title: "Ecosystem Growth & Expansion",
		points: [
			"Expansion into Crypto-Friendly Jurisdictions (UAE, EU, Asia)",
			"Institutional Partnerships for Remittance & Payment Gateways",
			"Governance Voting & DAO Implementation for Community Decisions",
			"UniWallet Pay Debit Card & Fiat-Crypto Platform Development",
		],
	},
	{
		quarter: "Q5",
		phase: "Phase 5",
		title: "Global Adoption & Future Innovations",
		points: [
			"Expansion into Retail & E-Commerce Payment Networks",
			"AI-Powered Transaction Analytics & DeFi Integrations",
			"Multi-Blockchain Support for Ethereum, BSC, Polygon & Layer-2 Scaling",
			"Establishing UWPS as a Leading Web3 Financial Ecosystem",
		],
	},
];


const PathAhead = () => {
	useEffect(() => {
		AOS.init({
			duration: 800,
			once: false,
		});
		AOS.refresh();
	}, []);
	return (
		<div className="roadmap" id="roadmap">
			<div className="container">
				<h2 className="roadmap_title">The Path Ahead</h2>
				<p className="roadmap_description">
					Witness the growth of UniWallet Pay as we revamp the financial structures.
				</p>
				<div className="roadmap_container">
					{roadmapData.map((item, index) => (
						<div className="roadmap_card" key={index} data-aos="fade-top-right"
							data-aos-delay={index * 400}>
							<h3 className="roadmap_quarter">{item.quarter}
								<button className="roadmap_phase">{item.phase}</button>

							</h3>
							<h4 className="roadmap_heading">{item.title}</h4>
							<ul className="roadmap_list">
								{item.points.map((point, idx) => (
									<li key={idx} className="roadmap_item">{point}</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default PathAhead;
